<body>
    <h2>Find your Footprint!</h2>
    <div class="links">
      <a  class="button" target="blank" (click)="this.router.navigateByUrl('/car');">Car Travel</a>
      <a  class="button" target="blank" (click)="this.router.navigateByUrl('/flight');">Flight Travel</a>
      <a class="button" target="blank" (click)="this.router.navigateByUrl('/motorbike');">Motor Bike</a>
      <a  class="button" target="blank" (click)="this.router.navigateByUrl('/publictransit');">Public Transit</a>
      <a  class="button" target="blank" (click)="this.router.navigateByUrl('/fuelco2');">Fuel to CO2 equivalent</a>
      <a  class="button" target="blank"(click)="this.router.navigateByUrl('/paper');">Calculate how many trees it took to create paper.</a>
      <!-- <a  class="button" target="blank">Fuel to CO2 equivalent</a> -->
     <a  class="button" target="blank" (click)="this.router.navigateByUrl('/personalcarbon')">Personal Carbon Footprint</a>
      <!--  <a href="http://twitter.com/redlotusdesignz" class="button" target="blank">Fuel to CO2 equivalent</a>
      <a href="http://twitter.com/redlotusdesignz" class="button" target="blank">Fuel to CO2 equivalent</a>-->
    </div> 
  </body>